/**
 * Newsletter - Newsletter section with form
 *
 * Wraps NewsletterForm with title and description.
 * Uses Card from @/components/ui/ (Infrastructure)
 */

import { NewsletterForm } from './NewsletterForm'
import { Card, CardContent } from '../../../Theme'

/**
 * Newsletter section component
 */
export function Newsletter() {
  return (
    <Card className="w-full md:max-w-screen-xl md:mx-auto bg-gray-100 border-0 shadow-none">
      <CardContent className="flex flex-col md:flex-row items-center justify-around p-5 gap-5">
        <div className="flex flex-col items-center xl:items-start justify-center w-full xl:w-2/5">
          <h3 className="text-center md:text-left font-main-font text-lg font-semibold">
            Abonati-va la newsletter
          </h3>
          <p className="text-center md:text-left font-main-font text-base">
            Si va vom tine la curent cu cele mai noi promotii.
          </p>
        </div>
        <div className="flex flex-col items-center justify-center w-full md:w-3/5 mt-3 md:mt-auto">
          <NewsletterForm />
          <p className="text-left font-main-font text-xs mt-2">
            Inscriindu-te esti de acord sa primesti oferte promotionale pe
            emailul furnizat, in concordanta cu politica de Prelucrarea
            datelor personale. Te vei putea dezabona in orice moment.
          </p>
        </div>
      </CardContent>
    </Card>
  )
}
